<template>
    <el-card class="profile">
        <div slot="header" class="clearfix">
            <span>{{id?'新增投票':('编辑 #'+id+' 投票')}}</span>
        </div>
        <div>
            <el-form :model="single" label-width="120px" ref="editForm">
                <el-row style="padding-right: 20px;">
                    <el-col :span="24" :md="12">
                        <el-form-item label="主题:" prop="subject" :rules="[{required: true, message: '主题不能为空'}]">
                            <el-input v-model="single.subject"
                                      placeholder="请输入主题"
                                      type='text'
                                      size="small">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" :md="12">
                        <el-form-item label="用户:">
                            <el-select v-model="single.visitor_id"
                                       placeholder="请输入用户的id"
                                       :disabled="user.role_level<4"
                                       class="w-100"
                                       filterable
                                       size="small">
                                <el-option v-for="(x,id) in single.visitors" :key="id" :value="id"
                                           :label="x"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <div class="clearfix"></div>
                </el-row>
                <el-row>
                    <el-table :data="single.items" style="width: auto;">
                        <el-table-column
                                label="操作"
                                width="100">
                            <template slot-scope="scope">
                                <el-button circle plain type="primary" icon="el-icon-plus" size="mini"
                                           @click="addItemAfter(scope.$index)"></el-button>
                                <el-button circle plain type="danger" icon="el-icon-minus" size="mini"
                                           @click="deleteItem(scope.$index)"></el-button>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="排序"
                                width="180">
                            <template slot-scope="scope">
                                <el-input-number controls-position="right" size="small"
                                                 v-model="scope.row.order"></el-input-number>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="问题">
                            <template slot-scope="scope">
                                <el-input size="small" v-model="scope.row.question"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="类型"
                                width="100">
                            <template slot-scope="scope">
                                <el-select size="small" v-model="scope.row.answer_type">
                                    <el-option label="单选" value="0"></el-option>
                                    <el-option label="多选" value="1"></el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="选项">
                            <template slot-scope="scope">
                                <el-input type="textarea" size="small" v-model="scope.row.answers"></el-input>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-row>
            </el-form>
        </div>
        <div class="mt-4">
            <div class="line mb-3"></div>
            <el-button type="primary" @click.native="handleSubmit" :loading="process.loading">{{('提交')}}</el-button>
            <el-button @click="handleCancel">{{'放弃'}}</el-button>
        </div>
    </el-card>
</template>

<script>

    import {mapState} from "vuex";

    export default {
        mixins: [],
        name: 'admin-admin',
        data() {
            return {
                model: '',
                id: 0,
                single: {},
            }
        },
        created() {
            this.model = 'Admin.Poll';
            this.id = this.$route.params.id;
            const vm = this;
            this.$api(this.model + '.Get', {id: this.id}).then(res => {
                if (res.data.success) {
                    this.single = res.data.data;
                } else {
                    const text = res.data.text;
                    vm.$alert(text, '错误', {
                        confirmButtonText: '确定',
                        type: 'error',
                        callback: () => {
                            vm.$router.go(-1);
                        }
                    });
                }
            }).catch(() => {
                vm.$router.go(-1);
            });
        },
        computed: {
            ...mapState(['user', 'preset', 'process']),
        },
        methods: {
            addItemAfter(i) {
                this.single.items.splice(i + 1, 0, {
                    order: i + 2,
                    question: '添加问题',
                    answer_type: '0',
                    answers: '添加答案，请用逗号分割'
                });
            },
            deleteItem(i) {
                if (this.single.items.length > 1) {
                    this.$affirm('确定要删除?').then(() => {
                        this.single.items.splice(i, 1);
                    });
                }
            },
            handleCancel() {
                this.$router.go(-1);
            },
            handleSubmit() {
                this.$api(this.model+'.Edit',this.single,1).then(()=>{
                    this.$router.go(-1);
                });
            }
        }
    }

</script>

<style lang="scss">

</style>
